export type TGeoObjectType = {
  isContinent: boolean;
  isCountry: boolean;
  isRegion: boolean;
};

export const useGeoObjectType = (id: string): TGeoObjectType => {
  return {
    isContinent: isContinent(id),
    isCountry: isCountry(id),
    isRegion: isRegion(id),
  };
};

export const isContinent = (id: string) => {
  return id.includes('k-');
};

export const isCountry = (id: string) => {
  return id.includes('c-');
};

export const isRegion = (id: string) => {
  return id.includes('r-');
};
